<template>
  <div>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
            <div class="d-flex gap-2">
              <v-text-field
                v-model="search"
                class="me-3 mt-4"
                label="Enter Client Name"
                outlined
                dense
                :prepend-inner-icon="icons.mdiMagnify"
              >
              </v-text-field>
              <v-btn
                class="mt-4"
                color="primary"
                :loading="loadingData"
                @click="performSearch"
              >
                Search
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="clientList"
        item-key="id"
        class="table-rounded"
        :items-per-page="10"
        :loading="loadingData"
        loading-text="Loading... Please wait"
        no-data-text="Enter a client name and click Search"
      >
        <!-- avatar -->
        <template #[`item.abbr`]="{ item }">
          <v-avatar
            :color="item.color"
            size="40"
            :class="`${item.color} white--text font-weight-medium`"
          >
            <span class="text-base">{{ item.abbr }}</span>
          </v-avatar>
        </template>
        <!-- name -->
        <template #[`item.name`]="{ item }">
          <div class="d-flex flex-column">
            <span class="d-block font-weight-semibold text--primary text-truncate">{{ item.name }}</span>
            <!-- <small>{{ item.id }}</small> -->
          </div>
        </template>
        <!-- PIN/Id -->
        <!--
        <template #[`item.pin`]="{item}">
        <div class="d-flex flex-column">
          <span class="d-block font-weight-semibold text--primary text-truncate">{{ item.pin }}</span>
          <small>{{ item.id }}</small>
        </div>
        </template> -->
        <!-- status -->
        <template #[`item.status`]="{ item }">
          <v-chip
            small
            :color="roleStatusColor[roles[item.status]]"
            class="font-weight-medium"
          >
            {{ roles[item.status] }}
          </v-chip>
        </template>
        <!-- rate -->
        <!--
        <template #[`item.rate`]="{item}">
          ${{ item.rate || 0 }}
        </template>
        -->
        <!-- role -->
        <!--
        <template #[`item.role`]="{item}">
          <v-chip
            small
            :color="roleStatusColor[roles[item.role]]"
            class="font-weight-medium"
          >
            {{ roles[item.role] }}
          </v-chip>
        </template>
        -->
        <!-- Household -->
        <template #[`item.household`]="{ item }">
          <div class="d-flex flex-column">
            <span class="d-block font-weight-semibold text--primary text-truncate">{{ item.household }}</span>
            <small>members</small>
          </div>
        </template>
        <!-- menu -->
        <template #[`item.clientMenu`]="item">
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <!--
              <v-btn
                dark
                icon
                v-bind="attrs"
                v-on="on"
                color="primary"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
              -->
              <v-btn
                icon
                class="me-n3 mt-n2"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiDotsVertical }}
                </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="(menuOption, i) in clientMenuItems"
                :key="i"
                @click="menuClientHandler(menuOption.action, item.item)"
              >
                <v-list-item-title>{{ menuOption.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mdiDotsVertical, mdiMagnify } from '@mdi/js'
import { ref } from '@vue/composition-api'
import Swal from 'sweetalert2'
import { axiosInst } from '@/utils/axiosIns'

export default {
  setup() {
    const clientList = ref([])

    return {
      search: '',
      headers: [
        { text: 'Gender', value: 'abbr', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Ethnicity', value: 'ethnicity' },
        { text: 'ZIP', value: 'zip' },
        { text: 'Household', value: 'household' },
        { text: 'Status', value: 'status' },
        { text: '', value: 'clientMenu' },
      ],
      clientList,

      // origItems: [],

      dates: [],
      menu: false,

      roles: {
        true: 'Admin',
        false: 'User',
        inactive: 'Inactive',
        active: 'Active',
      },
      roleStatusColor: {
        User: 'secondary',
        Admin: 'primary',
        Inactive: 'error',
        Active: 'success',
      },

      clientMenuItems: [
        { action: 'visit', title: 'New visit' },
        { action: 'edit', title: 'Edit' },
        { action: 'delete', title: 'Delete' },
      ],

      icons: {
        mdiDotsVertical,
        mdiMagnify,
      },

      loadingData: false,
    }
  },

  methods: {
    async performSearch() {
      const name = this.search.trim()

      if (!name) return

      this.clientList = []
      this.loadingData = true

      try {
        const rs = await axiosInst.post('client-search', { name })

        if (rs.status === 200 && rs.data.error === false && Array.isArray(rs.data.r)) {
          rs.data.r.forEach(client => {
            this.clientList.push({
              abbr: client.gender.charAt(0),
              // eslint-disable-next-line no-underscore-dangle
              id: client._id,
              username: client.username,
              name: client.name,
              ethnicity: client.ethnicity,
              zip: client.zip,
              household: (client.household.length || 0) + 1, // plus primary member
              color: client.gender === 'Male' ? 'secondary' : 'warning',
              status: client.status === 1 ? 'active' : 'inactive',
            })
          })
        }
      } catch (err) {
        if (err?.response?.data?.r === 'session-ended') {
          this.$router.push({ name: 'pages-login' })
        }
        this.clientList = []
      } finally {
        this.loadingData = false
      }
    },

    menuClientHandler(action, clientData) {
      if (!action || Object.keys(clientData).length === 0) return

      if (action === 'delete') {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        }).then(result => {
          if (result.isConfirmed) this.deleteClient(clientData)
        })
      }
      if (action === 'edit') {
        this.editUser(clientData)
      }
      if (action === 'visit') {
        Swal.fire({
          title: 'Are you sure?',
          text: `A new visit will be registered for: ${clientData.name}`,
          icon: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, add it!',
        }).then(result => {
          if (result.isConfirmed) this.addVisit(clientData)
        })
      }
    },

    async deleteClient(clientData) {
      try {
        const rs = await axiosInst.post('client-remove', {
          userId: clientData.id,
        }).catch(err => { throw err })

        // console.log(rs)

        if (rs.status === 200 && rs.data.error === false) {
          Swal.fire('Deleted!', 'Client has been deleted.', 'success')
          this.clientList = this.clientList.filter(user => user.id !== clientData.id) // remove from table too
        }
      } catch (err) {
        console.error(err)
      }
    },

    editUser(clientData) {
      if (!clientData.id) return

      this.$router.push({
        name: 'users-edit-client',
        params: {
          clientId: clientData.id,
        },
      })
    },

    async addVisit(clientData) {
      // console.log(clientData)
      try {
        const rs = await axiosInst.post('client-post', { clientId: clientData.id })

        // console.log(rs)

        if (rs.status === 200 && rs.data.error === false) {
          Swal.fire('Added!', 'Record has been added.', 'success')
        }
      } catch (err) {
        const serverError = err.response.data || {}

        // console.error(serverError)

        if (serverError?.error === true) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: serverError.r,
          })
        }
      }
    },
  },
}
</script>
